// extracted by mini-css-extract-plugin
export var icon = "_6m-1";
export var subtext = "_6m-0";